import React from 'react';

import PageContent from 'components/PageContent';
import CurrencyNbuTable from 'components/CurrencyNbuTable';
// import NbuBarGraph from 'components/NbuBarGraph';
import CurrencyConverter from 'components/CurrencyConverter';
import AnotherCurrTable from 'components/AnotherCurrTable';
import ExchangeDiscussion from 'components/ExchangeDiscussion';
import CurrencyNews from 'components/CurrencyNews';
import NewsSlider from 'components/NewsSlider';
import Banner from 'components/Banner';

const NbuPageContent = () => (
  <PageContent>
    <CurrencyNbuTable />
    {/* <NbuBarGraph /> */}
    <Banner id="hp-react-banner-content-1" slot="bn-slot-content-1" />
    <CurrencyConverter optionType="nbu" />
    <AnotherCurrTable />
    <ExchangeDiscussion />
    <NewsSlider />
    <CurrencyNews />
  </PageContent>
);

export default NbuPageContent;
